module.exports = __webpack_public_path__ + "static/img/2.98391e9.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/2/4/sp/2.png
// module id = WdZ7
// module chunks = 0